import { Injectable, signal } from "@angular/core";

type ThemeType = "dark" | "default" | string;

@Injectable({
    providedIn: "root",
})
export class ThemeService {
    themeName = signal<ThemeType>("default");

    private reverseTheme(theme: ThemeType): ThemeType {
        return theme === "dark" ? "default" : "dark";
    }

    private removeUnusedTheme(theme: ThemeType): void {
        document.documentElement.classList.remove(theme);
        const removedThemeStyle = document.getElementById(theme);
        if (removedThemeStyle) {
            document.head.removeChild(removedThemeStyle);
        }
    }

    private loadCss(href: string, id: string): Promise<Event> {
        return new Promise((resolve, reject) => {
            if (typeof document !== "undefined") {
                const style = document.createElement("link");
                style.rel = "stylesheet";
                style.href = href;
                style.id = id;
                style.onload = resolve;
                style.onerror = reject;
                document.head.append(style);
            }
        });
    }

    public loadTheme(firstLoad = true): Promise<Event> {
        const theme = this.themeName();
        if (firstLoad && theme && typeof document !== "undefined") {
            document.documentElement.classList.add(theme);
        }
        return new Promise<Event>((resolve, reject) => {
            this.loadCss(`${theme}.css`, theme).then(
                (e) => {
                    if (!firstLoad && typeof document !== "undefined") {
                        document.documentElement.classList.add(theme);
                    }
                    this.removeUnusedTheme(this.reverseTheme(theme));
                    resolve(e);
                },
                (e) => reject(e)
            );
        });
    }

    public toggleTheme(): Promise<Event> {
        this.themeName.set(this.reverseTheme(this.themeName()));
        return this.loadTheme(false);
    }
}
